import React from "react";
import './MahutiInputTimeItem.css'
import { isMobile } from "react-device-detect";
import RadioEmpty from "../../svg/radioEmpty";
import RadioChecked from "../../svg/radioChecked";

export default function MahutiInputTimeItem(props) {

    return <div className={`mahutiInputTimeItem card rounded-0 p-3 ${props.length > 1 ? 'time_box_border' : ''}`}>
                <div className="card-body p-1">
                    <div className="d-flex align-items-center">
                        <div className="me-4">
                            <label className="pointer" htmlFor={props.lineId}>{props.isSelected ? <RadioChecked/> : <RadioEmpty/>}</label>
                            <input type='radio' id={props.lineId} className="invisible position-absolute" name='mahutiInputTimeactivity' checked={props.isSelected} onChange={() => props.setMyTime(props.activityTime)}/>
                        </div>
                        <div className="text-start">
                            <span className="fw-bold header-detail">{props.activityTime.startTime}</span>
                            <span className="px-1">-</span>
                            <span className='fw-bold header-detail'>{props.activityTime.endTime}</span>{isMobile && <br/>}
                            {props.activityTime.started && <span className={`fw-bold input_alert time_alert ${!isMobile && 'ms-3'}`}>{!isMobile && 'לתשומת ליבך, '} הפעילות כבר החלה</span>}
                        </div>
                    </div>
                </div>
            </div>
}